module.exports = __webpack_public_path__ + "img/img-txtsentbiz.f19ee73a.svg";